export function parseHashParams(hash: string): URLSearchParams | undefined {
  if (hash === "") return undefined;
  const paramsStartIndex = hash.indexOf("?");
  if (paramsStartIndex < 0 || paramsStartIndex >= hash.length - 1)
    return undefined;
  let params = hash.substring(paramsStartIndex + 1);
  const hashIndex = params.indexOf("#");
  if (hashIndex >= 0) {
    params = params.substring(0, hashIndex);
  }
  return new URLSearchParams(params);
}

export function getUrlSearchParams(): URLSearchParams | undefined {
  if (typeof window === "undefined") {
    return;
  }
  const { searchParams, hash } = new URL(window?.location.href);
  const hashParams = parseHashParams(hash);
  if (hashParams) {
    hashParams.forEach((value, key) => {
      if (!searchParams.has(key)) {
        searchParams.append(key, value);
      }
    });
  }
  return searchParams;
}
